/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import styles from './styles.scss';


const defaultProps = {
  placement: 'right',
  message: '',
};

const propTypes = {
  show: React.PropTypes.bool.isRequired,
  message: React.PropTypes.node,
  azStyle: React.PropTypes.oneOf([
    'danger',
    'info',
    'primary',
    'success',
    'warning',
  ]).isRequired,
  placement: React.PropTypes.oneOf([
    'top',
    'right',
    'bottom',
    'left',
  ]).isRequired,
};

class ControlTips extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      message: props.message,
      show: props.show,
      azStyle: props.azStyle,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { message, show, azStyle } = nextProps;
    if (message !== this.props.message) {
      this.setState({ message });
    }
    if (show !== this.props.show) {
      this.setState({ show });
    }
    if (azStyle !== this.props.azStyle) {
      this.setState({ azStyle });
    }
  }

  render() {
    const { placement } = this.props;
    const { message, show, azStyle } = this.state;
    if (show) {
      return (
        <div className={`${styles.wrapper} ${styles[placement]}`}>
          <div className={`${styles.tips} ${styles[azStyle]} ${styles[placement]}`}>
            {message}
            <div className={`${styles.arrow} ${styles[azStyle]} ${styles[placement]}`} />
          </div>
        </div>
      );
    }
    return null;
  }
}

ControlTips.defaultProps = defaultProps;
ControlTips.propTypes = propTypes;

export default ControlTips;




// WEBPACK FOOTER //
// ./src/components/ControlTips/index.jsx